module.exports = __webpack_public_path__ + "static/media/menu-items.e779566d.png";